interface DamageMetaInput {
	damageType?: string;
	material?: string;
	size?: string;
}

const stripDamagePrefix = (str: string): string =>
	str.replace(/^damage_/i, '');

const toTitleCase = (str: string): string =>
	str
		.replace(/_/g, ' ')
		.replace(/\b\w/g, (char) => char.toUpperCase());

export const formatDamageMeta = (meta: DamageMetaInput | null | undefined): string => {
	if (!meta) return '';

	const damageType = meta.damageType ? stripDamagePrefix(meta.damageType) : meta.damageType;

	return [damageType, meta.material, meta.size]
		.filter((segment): segment is string => Boolean(segment))
		.map(toTitleCase)
		.join(' · ');
};

export type { DamageMetaInput };
